import { tomanParts } from "../../utils/persian";

const Money = ({ value, className = "", negative = false }) => {
  const parts = tomanParts(value);

  return (
    <span className={`jooti-money ${negative ? "is-negative" : ""} ${className}`.trim()}>
      {negative && <span className="jooti-money-sign">−</span>}
      <span className="jooti-money-amount">{parts.amount}</span>
      <span className="jooti-money-currency">{parts.currency}</span>
    </span>
  );
};

export default Money;
